import { render, staticRenderFns } from "./EditLevelNotes.vue?vue&type=template&id=8076d664&scoped=true&"
import script from "./EditLevelNotes.vue?vue&type=script&lang=js&"
export * from "./EditLevelNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8076d664",
  null
  
)

export default component.exports